import { jsx } from 'react/jsx-runtime';

// src/components/BuildingLogoChip.tsx
function BuildingLogoChip({
  logoUrl,
  buildingName,
  maxHeight = 48,
  className,
  alt
}) {
  const resolvedAlt = alt ?? (buildingName ? `${buildingName} logo` : "Building logo");
  if (logoUrl) {
    return /* @__PURE__ */ jsx(
      "img",
      {
        src: logoUrl,
        alt: resolvedAlt,
        className,
        style: {
          maxHeight,
          width: "auto",
          display: "inline-block",
          verticalAlign: "middle"
        }
      }
    );
  }
  if (buildingName && buildingName.trim().length > 0) {
    const initials = buildingName.trim().slice(0, 2).toUpperCase();
    const size = maxHeight;
    return /* @__PURE__ */ jsx(
      "span",
      {
        className,
        role: "img",
        "aria-label": resolvedAlt,
        style: {
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          height: size,
          minWidth: size,
          padding: "0 8px",
          borderRadius: 8,
          backgroundColor: "var(--caro-primary)",
          color: "#FFFFFF",
          fontFamily: "var(--caro-font, system-ui, -apple-system, sans-serif)",
          fontWeight: 700,
          // Scale initials with the chip; ~45% of height reads well at 32–64px.
          fontSize: Math.round(size * 0.45),
          letterSpacing: 1,
          lineHeight: 1,
          userSelect: "none"
        },
        children: initials
      }
    );
  }
  return null;
}

export { BuildingLogoChip };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map